import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CookiesService } from 'app/core/auth/_services/cookies.service';
import { UserDataModel } from '../models/user-data-model';
import { Router } from '@angular/router';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthorizationService {

    private API_AUTH_URL = environment.ipserver + 'AnA-backend/public/authorization/isAuthorized';

    /**
     * Verify session url
     */
    private VERIFY_SESSION_URL = environment.ipserver + 'AnA-backend/private/verifyClosedSession';

    constructor(
        private http: HttpClient,
        private cookiesService: CookiesService,
		private router: Router,
    ) { }

    isAuthorized(username: string, componentAsParam: string, applicationAsParam: string): Observable<boolean> {
        const paramsReq = new HttpParams()
            .set('user', username)
            .set('component', componentAsParam)
            .set('application', applicationAsParam);
        const type = 'text' as 'json';
        return this.http.post<boolean>(this.API_AUTH_URL, '', { params: paramsReq, responseType: type }).pipe(
            map((auth) => {
                if (typeof auth === 'string') {
                    auth = JSON.parse(auth);
                }
                return auth;
            })
        );
    }



    /**
     * Verify if the session was closed due to
     * a change of password
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-09-28
     */
    public verifyClosedSession(): Observable<boolean> {
        const userData: UserDataModel = JSON.parse(this.cookiesService.getCookie('_remCred_', true));
        
    /*    var someDate = new Date(userData.signInDate);
        const today = new Date()
        if( someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()    
    )
    {
        return of(false);
    }
    else
    {
        return of(true);
    }*/
 
       

      
        const paramsForReq = new HttpParams()
            .set('signInDate', userData.signInDate);
        const type = 'text' as 'json';
        return this.http.get<boolean>(this.VERIFY_SESSION_URL, { params: paramsForReq, responseType: type })
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                })
				);
    }
}
